var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"retangular-button",class:{colorRoxo: _vm.color === 'roxo', colorVermelho: _vm.color === 'vermelho', colorAzul: _vm.color === 'azul', colorBranco: _vm.color === 'branco', colorTeste: _vm.color === 'teste'}},[_c('h3',[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }